import { render } from "./ChallengesPage.vue?vue&type=template&id=7b547f04"
import script from "./ChallengesPage.vue?vue&type=script&lang=js"
export * from "./ChallengesPage.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__